import React, { useRef, useEffect } from 'react'
import { gsap, ScrollTrigger } from 'gsap/all'
import PhilosophyAbout from './PhilosophyAbout';
import { timeToReadyTl } from '../../utils/gsapService';

export default function Philosophy() {
  gsap.registerPlugin(ScrollTrigger);
  const fixedSection = useRef(null);
  const fixedSectionWrap = useRef(null);

    useEffect(() => {  
        gsap.set(fixedSectionWrap.current, { 
            yPercent:-100 
        })
        let tlTop = gsap.timeline();
        let tlBottom = gsap.timeline(); 

        const startAni = setTimeout(()=>{ 
            gsap.to(fixedSectionWrap.current, {
                yPercent:0,
                scrollTrigger:{  
                    trigger:fixedSection.current,
                    start:()=>{
                        return `top +=${window.innerHeight}`
                    }, 
                    end:()=>{
                        return `+=${window.innerHeight}`
                    },
                    scrub:true,
                    scroller:"#main-container", 
                },
                ease:"none"
            });
            
            ScrollTrigger.refresh(); 
        }, timeToReadyTl.firstDelay);
        ScrollTrigger.refresh();  
        return ()=>{
            clearTimeout(startAni);
            tlTop.kill();
        }
    }, []);

  return (
    <>
        <section className="fixed-section" ref={fixedSection}> 
            <div className="fixed-section-wrapper" ref={fixedSectionWrap}> 
                <div className="container h-100 d-flex align-items-center justify-content-center">
                    <h2 className="title-xl">Philosophy</h2>
                </div>
            </div>
        </section>
        <PhilosophyAbout/> 
    </>
  )
}